import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBgLU71IKfA_NKAMIOiwyKdfAylXDqf2nc",
  authDomain: "cursofirebase-b5d58.firebaseapp.com",
  projectId: "cursofirebase-b5d58",
  storageBucket: "cursofirebase-b5d58.firebasestorage.app",
  messagingSenderId: "498836315465",
  appId: "1:498836315465:web:02b3596dba265c3c6f0e98"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth }



// Para o build usar o .env
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID
// };
